import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

// 全局引入
import Vant from 'vant'
import 'vant/lib/index.css';
import '@/assets/css/fonts.css';
import copyDirective from '@/assets/js/copy'
Vue.directive('copy', copyDirective)
Vue.use(Vant)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  i18n, // 注入 i18n
}).$mount('#app')